import type { ESGTranslations } from "../../types/esg";

export const esg: ESGTranslations = {
  title: "ESG Aruanne",
  overview: "Ülevaade",
  metrics: "Detailsed ESG Mõõdikud",
  generalDisclosures: "ESRS 2 Üldised Avalikustamised",
  exportReport: "Ekspordi Aruanne",
  exportSuccess: "ESG Aruanne Genereeritud",
  exportSuccessDesc: "Teie ESG aruanne on edukalt alla laaditud.",
  exportError: "ESG aruande genereerimine ebaõnnestus",
  errorTitle: "Viga",
  errorLoadingMetrics: "ESG mõõdikute laadimine ebaõnnestus",
  errorCreateMetrics: "ESG mõõdikute loomine ebaõnnestus",
  loadError: "ESG andmete laadimine ebaõnnestus",
  saveError: "ESG andmete salvestamine ebaõnnestus",
  loading: "Laen ESG andmeid...",
  empty: "ESG andmed puuduvad",
  buildingNotFound: "Hoonet ei leitud",
  updateSuccessTitle: "Uuendamine Õnnestus",
  updateSuccessDesc: "ESG mõõdikud on edukalt uuendatud.",
  updateErrorDesc: "ESG mõõdikute uuendamine ebaõnnestus",
  detailedMetrics: {
    energyConsumption: "Energiatarbimine",
    renewableEnergy: "Taastuvenergia",
    waterConsumption: "Veetarbimine",
    wasteGenerated: "Tekkinud Jäätmed",
    wasteRecycled: "Ringlussevõetud Jäätmed",
    ghgEmissions: "Kasvuhoonegaaside Heide",
    biodiversityArea: "Bioloogilise Mitmekesisuse Ala",
    accessibilityScore: "Ligipääsetavuse Skoor",
    occupantSatisfaction: "Elanike Rahulolu",
    healthSafety: "Tervishoid ja Ohutus",
    communityEngagement: "Kogukonna Kaasamine",
    tenantSatisfaction: "Üürnike Rahulolu",
    airQuality: "Õhu Kvaliteet",
    governanceStructure: "Juhtimisstruktuur",
    riskAssessment: "Riskihindamine",
    stakeholderEngagement: "Sidusrühmade Kaasamine",
    sustainabilityDueDiligence: "Jätkusuutlikkuse Hoolsuskohustus",
    boardExpertise: "Nõukogu Pädevus",
    performanceIntegration: "Tulemuslikkuse Integreerimine",
    processEstablished: "Protsess on loodud ja dokumenteeritud",
    committeeEstablished: "Jätkusuutlikkuse komitee on loodud",
    metricsInIncentives: "ESG mõõdikud motivatsiooniskeemides",
    hours: "tundi",
    certifications: "Sertifikaadid",
    sustainabilityPolicies: "Jätkusuutlikkuse Poliitikad",
    esgRiskScore: "ESG Riskiskoor",
    supplierCodeOfConduct: "Tarnija Käitumisjuhend",
    scope1: "Ulatus 1",
    scope2: "Ulatus 2",
    resourceConsumption: "Ressursside Tarbimine",
    // Add missing properties
    trainingHours: "Koolitustunnid",
    diversityRatio: "Mitmekesisuse Suhtarv",
    workforceManagement: "Töötajaskonna Juhtimine",
    workerEngagement: "Töötajate Kaasamine",
    socialProtection: "Sotsiaalne Kaitse",
    valueChainManagement: "Väärtusahela Juhtimine",
    workerConditions: "Töötingimused",
    circularDesign: "Ringdisain",
    circularStrategies: "Ringmajanduse Strateegiad",
    resourceManagement: "Ressursside Juhtimine",
    conservationTargets: "Looduskaitse Eesmärgid",
    restorationPlans: "Taastamise Plaanid",
    biodiversityManagement: "Bioloogilise Mitmekesisuse Juhtimine",
    marineProtection: "Merekaitse",
    waterStressAreas: "Veepuudusega Alad",
    marineResources: "Mereressursid",
    waterManagement: "Veemajandus",
    reachCompliance: "REACH Vastavus",
    remediationCases: "Parandamisjuhtumid",
    grievanceChannels: "Kaebuste Kanalid",
    grievanceCases: "Kaebuste Juhtumid",
    investment: "Investeering",
    engagementEffectiveness: "Kaasamise Tõhusus",
    consumerProtection: "Tarbijakaitse",
    productSafety: "Tooteohutus",
    complaintsResolved: "Lahendatud Kaebused",
    customerSatisfaction: "Kliendi Rahulolu",
    categories: "Kategooriad",
    costs: "Kulud",
  },
  sections: {
    environmental: "Keskkond",
    social: "Sotsiaalne",
    governance: "Juhtimine",
  },
  tabs: {
    climate: "Kliimamuutus (E1)",
    pollution: "Saaste (E2)",
    water: "Vesi ja Mereressursid (E3)",
    biodiversity: "Bioloogiline Mitmekesisus (E4)",
    resource: "Ressursikasutus (E5)",
    workforce: "Oma Töötajad (S1)",
    valueChain: "Väärtusahel (S2)",
    communities: "Kogukonnad (S3)",
    consumers: "Tarbijad (S4)",
  },
};
